import {createContext} from "react";
import {DialogId} from ".";

type OptionalIfUndefined<T> = undefined extends T ? [dialogProps?: T] : [dialogProps: T];

export interface OpenDialog {
  <T>(dialogId: DialogId<T>, ...[dialogProps]: OptionalIfUndefined<T>): void;
}

type DialogContext = {open: OpenDialog};

function defaultOpen<T>(dialogId: DialogId<T>, _dialogProps?: T) {
  console.error(`No such dialog: ${dialogId.description}`);
}

export const dialogContext = createContext<DialogContext>({open: defaultOpen});
